import { toast } from "sonner";
import { Plus } from "lucide-react";
import { inr, mediaUrl } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { SectionHead } from "@/components/site/SectionHead";
import { useLang } from "@/context/LangContext";

export default function Store({ products }) {
  const { add } = useCart();
  const { t, item } = useLang();
  return (
    <section id="store" className="bg-parchment-200">
      <div className="max-w-6xl mx-auto px-5 py-20 sm:py-28">
        <SectionHead eyebrow={t("st.eyebrow")} title={t("st.title")} text={t("st.text")} />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {products?.map((p) => {
            const [name, desc] = item(p.id, p.name, p.desc);
            return (
            <article key={p.id} className="group bg-white rounded-2xl overflow-hidden border border-parchment-300 flex flex-col" data-testid={`product-card-${p.id}`}>
              <div className="aspect-square overflow-hidden bg-parchment-200">
                <img src={mediaUrl(p.image)} alt={name} data-testid={`product-image-${p.id}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-4 sm:p-5 flex flex-col flex-1">
                <h3 className="text-lg sm:text-xl font-semibold text-forest-800 leading-tight">{name}</h3>
                <p className="mt-1.5 text-xs sm:text-sm text-[#57645A] flex-1">{desc}</p>
                <div className="mt-4 flex items-center justify-between gap-2">
                  <span className="font-serif text-xl sm:text-2xl font-bold text-forest-800">{inr(p.price)}</span>
                  <button onClick={() => { add(p); toast.success(t("st.added", { n: name })); }} className="flex items-center gap-1 px-3 sm:px-4 py-2 rounded-full bg-forest-800 text-parchment text-xs sm:text-sm hover:bg-forest-700 transition-colors" data-testid={`product-add-${p.id}`}>
                    <Plus className="w-3.5 h-3.5" /> {t("st.add")}
                  </button>
                </div>
              </div>
            </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
